import o from "./index220.js";
/* empty css         */
import t from "./index130.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-ed3712b6"]]);
export {
  p as default
};
